import {configureStore, combineReducers} from '@reduxjs/toolkit'
import authReducer from './reducers/auth.slice'
import filterReducer from './reducers/filter.slice'
const reducers = combineReducers({
  auth: authReducer,
  filter: filterReducer,
})

export const store = configureStore({
  reducer: reducers,
  //   middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
